<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <template>
            <a-col :md="8" :sm="12">
              <a-form-item :label="$t(I18N_KEY + 'dataDate')">
                <a-range-picker v-model="queryParam.createdTime" format="YYYY-MM-DD" />
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="16" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'teleMarketUser')">
              <template>
                <a-select
                  v-model:value="queryParam.user"
                  show-search
                  :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'teleMarketUser')"
                  style="width: 100%"
                  mode="multiple"
                  :allowClear='allowClear'
                >
                  <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                  <a-select-option v-for="item in teleMarketUsers" :value="item.value">
                    {{item.label }}
                  </a-select-option>
                </a-select>
              </template>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'loanType')">
              <a-select v-model="queryParam.loanType" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in loanTypes' :key='item.label'>
                  <!--                  {{$t(I18N_KEY + 'loanType_' + item.label)}}-->
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="16" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'type')">
              <a-select v-model="queryParam.type" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in types' :key='item.value'>
                  <!--                  {{$t(I18N_KEY + 'type_' + item.label)}}-->
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'userGroupName')">
              <a-select v-model="queryParam.groupId" :placeholder="$t('select')" style="width: 100%;" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for="item in userGroups" :value="item.value">
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
<!--          <a-col :md="16" :sm="12">-->
<!--            <a-form-item :label="$t(I18N_KEY + 'app')">-->
<!--              <a-select v-model="queryParam.appSsid" :placeholder="$t('select')" style="width: 100%;" mode="multiple" :allowClear='allowClear'>-->
<!--                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>-->
<!--                <a-select-option v-for="item in apps" :value="item.appSsid">-->
<!--                  {{ item.appSsid + '/' + item.appName }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
        </a-row>
        <a-row :gutter="24">
          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <a-button type="primary" v-if='view' @click="downLoadData" icon="search" style="margin-left: 8px">{{ $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
      </a-table>
      <!--:scroll="{ x: 1500 }"-->
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
    </div>
  </div>
</template>
<script>
import { filterObj } from '@/utils/util';
import {t0Convert, baseData} from '@/webpublicapi/teleMarket';
import vModal from "@/views/webpublic/modules/Modal";
import {mapGetters} from "vuex";
import moment from 'moment/moment'
import exportFile from "@/webpublicapi/exportFile";
const I18N_KEY = 'teleMarket.';
export default {
  name: 'teleMarketT0Convert',
  components: {
    vModal
  },
  data () {
    return {
      I18N_KEY,
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      view: false,
      allowClear: true,
      total: 0,
      dataSource: [],
      apps: [],// Package list
      teleMarketUsers: [],// Telemarketer list
      userGroups: [],// Telemarketer list
      types: [],// Type list
      loanTypes: [{"label":"1", "value":"1"},{"label": "2", "value":"2"},{"label":"3","value":"3"},{"label":"4","value":"4"},{"label":"5","value":"5"}],// First/repeat loan type1-First collection,2-Repeat loan,3-First/repeat loan,4-Early settlement
      // Query conditions
      queryParam: {
        "createdTime": [],
        "type": [],
        "user": [],
        "loanType": [],
        "groupId": [],
      },
      fieldName: 'textCn',
      loading: false,
      // Table header
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'dataDate'),
          align: 'center',
          width: '130',
          dataIndex: 'dataDate'
        },
        {
          title: this.$t(I18N_KEY + 'teleMarketUser'),
          align: 'center',
          width: '100',
          dataIndex: 'user',
          customRender: (text, record) => {
            var text = text;
            return this.getUserLabel(text);
          }
        },
        {
          title: this.$t(I18N_KEY + 'userGroupName'),
          align: 'center',
          width: '100',
          dataIndex: 'groupId',
          customRender: (text, record) => {
            var text = text;
            for(var i in this.userGroups) {
              if(text == this.userGroups[i].value) {
                return this.userGroups[i][this.fieldName]
              }
            }
            return text;
          }
        },
        {
          title: this.$t(I18N_KEY + 'type'),
          align: 'center',
          width: '200',
          dataIndex: 'type',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.types) {
                if(text === this.types[i].value) {
                  return this.types[i][this.fieldName]
                }
              }
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'assignNum'),
          align: 'center',
          dataIndex: 'totalNum'
        },
        // {
        //   title: this.$t(I18N_KEY + 'callNum'),
        //   align: 'center',
        //   dataIndex: 'callNum'
        // },
        // {
        //   title: this.$t(I18N_KEY + 'connectNum'),
        //   align: 'center',
        //   dataIndex: 'connectNum'
        // },
        {
          title: this.$t(I18N_KEY + 'convertNumT0'),
          align: 'center',
          dataIndex: 'convertNumT0'
        },
        {
          title: this.$t(I18N_KEY + 'convertRateT0'),
          align: 'center',
          dataIndex: 'convertRateT0',
        },
        {
          title: this.$t(I18N_KEY + 'passNumT0'),
          align: 'center',
          dataIndex: 'passNumT0',
          customRender: (text, record) => {
            var text = text;
            var type = record.type;
            if(this.checkType(type)) {
              return '-'
            }
            return text;
          }
        },
        {
          title: this.$t(I18N_KEY + 'passRateT0'),
          align: 'center',
          dataIndex: 'passRateT0',
          customRender: (text, record) => {
            var text = text;
            var type = record.type;
            if(this.checkType(type)) {
              return '-'
            }
            return text;
          }
        },
      ]
    },
  },
  created () {
    this.loadBaseData();// Load telemarketer list, type list, package list
    // this.loadData(1);
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadBaseData() {
      baseData({}).then((res) => {
        if (res.code === 1000) {
          this.teleMarketUsers = res.data.seats;
          this.types = res.data.types;
          this.apps = res.data.apps;
          this.view = res.data.view;
          this.loanTypes = res.data.loanTypes;
          this.userGroups = res.data.userGroups;
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      t0Convert(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
          // this.totalData = res.data.convert
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    getQueryParams() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: createdTime && this.transformTime(createdTime[0]),
        endDate: createdTime && this.transformTime(createdTime[1]),
      }
      // console.log(this.queryParam.createdTime)
      if(this.queryParam.createdTime.length === 0) {
        data['startDate'] = ''
        data['endDate']=''
      }
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase();
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    searchReset() {
      var that = this
      that.queryParam.appSsid = []
      that.queryParam.type = []
      that.queryParam.user = []
      that.queryParam.createdTime = []
      that.queryParam.loanType = []
      that.queryParam.groupId = []
    },
    handleReCreate(record) {
      const data = {
        account: record.account,
        type: record.type,
        dateLabel: record.dateLabel
      }
      var param = Object.assign({}, data)
      this.doCreate(filterObj(param))
    },
    getUserLabel(user) {
      for(var item in this.teleMarketUsers) {
        var userObj = this.teleMarketUsers[item];
        if(userObj.value === user){
          return userObj.label;
        }
      }
    },
    getAppName(appSsid) {
      for(var item in this.apps) {
        var appObj = this.apps[item];
        if(appObj.appSsid === appSsid) {
          return appSsid+ '/'+appObj.appName;
        }
      }
      return appSsid;
    },
    getQueryParams1() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: createdTime && this.transformTime(createdTime[0]),
        endDate: createdTime && this.transformTime(createdTime[1]),
      }
      if(this.queryParam.createdTime.length === 0) {
        data['startDate'] = ''
        data['endDate']=''
      }
      return Object.assign({}, data)
    },
    downLoadData () {
      const params = this.getQueryParams1()// Query conditions
      const file = {
        fileUrl: '/api/web/webpublic/telemarket/report/t0Convert/export?startDate=' + this.checkParam(params.startDate) + '&endDate=' + this.checkParam(params.endDate) + '&user=' + this.checkArrayParam(params.user) + '&type=' + this.checkArrayParam(params.type) + '&loanType=' + this.checkArrayParam(params.loanType) + '&groupId=' + this.checkArrayParam(params.groupId),
        fileName: 'teleMarketT0T7Convert.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    checkParam(p){
      if(p===null || p === 'null' || p === undefined || p === 'undefined') {
        return '';
      }
      return p;
    },
    checkArrayParam(p){
      if(p===null || p === 'null' || p === undefined || p === 'undefined') {
        return [];
      }
      return p;
    },
    checkType(type) {
      if(type == '8' || type == '9' || type == '23' || type == '24' || type == '15' || type == '16' || type == '25' || type == '26') {
        return true
      }
      return false;
    },
  },
  watch: {
    languageStorage: {
      handler (lang) {
        if (lang == 'en-US') {
          this.fieldName = 'textEn';
        } else if (lang == 'es') {
          this.fieldName = 'textEs';
        } else {
          this.fieldName = 'textEn';
        }
      },
      immediate: true,
    }
  },
}
</script>